<div class="gl-page">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Grootboekrekeningengroep</h1>

    <div class="gl-page__header-actions">
      <yds-button variant="primary" (click)="navigateToCreate()">
        Grootboekrekeningengroep toevoegen
      </yds-button>
    </div>
  </div>

  @if (isLoading()) {
    <yds-card>
      <div class="gl-list-state">
        <yds-spinner [label]="'Grootboekrekeningengroepen laden...'" />
      </div>
    </yds-card>
  } @else if (tableItems().length === 0) {
    <yds-empty-states [message]="'Er zijn nog geen Grootboekrekeningen'" />
  } @else {
    <yds-card>
      <div class="gl-list-table">
        <yds-table
          [embedded]="true"
          [showPaginationFooter]="generalLedgerGroups().length > 0"
          [columns]="tableColumns"
          [items]="tableItems()"
          [zebra]="true"
          [dottedColumns]="true"
          [clickable]="true"
          (rowClick)="onTableRowClick($event)"
        >
          <ng-template ydsTableCell="actions" let-item="item">
            <yds-split-button
              label="Bekijk details"
              [items]="splitButtonItems"
              variant="default"
              size="sm"
              (mainClick)="viewItem(item.id, $event)"
              (itemClick)="handleActionClick(item.id, $event)"
            ></yds-split-button>
          </ng-template>

          @if (generalLedgerGroups().length > 0) {
            <yds-pagination
              pagination
              [(pageIndex)]="pageIndex"
              [pageSize]="pageSize"
              [totalItems]="generalLedgerGroups().length"
            />
          }
        </yds-table>
      </div>
    </yds-card>
  }
</div>
